<template>
  <div>
    <div id="map-main">
      <GmapMap
        :center="center"
        :zoom="zoom"
        :options="gmapsOptions"
        style="width: 100%; height: 100%"
        ref="gmap"
        @zoom_changed="zoom = $event"
        @center_changed="UpdateCenter"
        @idle="Idle"
      >
        <gmap-info-window
          :position="infoWindowPos"
          :opened="infoWinOpen"
          :options="infoOptions"
          @closeclick="infoWinOpen = false"
          style="width: 300px"
        >
          <div class="map-popup">
            <div class="infoBox-close" @click="CloseInfoWindow">
              <i class="fa fa-times"></i>
            </div>
            <div class="map-popup-category" :class="{ 'bg-green': isCleaned }">
              {{ $t($get(selectedData, 'Status')) }}
            </div>
            <slot
              name="infoWinData"
              :infoWinData="infoWinData"
              v-if="infoWinData"
            >
            </slot>
          </div>
        </gmap-info-window>

        <GmapCluster
          :minimumClusterSize="5"
          :zoomOnClick="false"
          :ignoreHidden="true"
          :gridSize="gridSize"
          @click="ClusterClick"
          ref="gmapCluster"
        >
          <GmapMarker
            class="gmap-marker"
            :key="m.id"
            v-for="m in visibleMarkers"
            :position="m.position"
            :icon="m.icon"
            :clickable="true"
            :draggable="false"
            @click="OpenInfoWindow(m.data[markerKey])"
            :visible="m.visible"
          />
        </GmapCluster>
      </GmapMap>
      <div class="noprint">
        <div @click="ZoomIn" class="mapzoom-in"></div>
        <div @click="ZoomOut" class="mapzoom-out"></div>
      </div>
      <!-- <ul class="mapnavigation noprint">
        <li>
          <a href="javascript:;" @click="Prev" class="prevmap-nav">{{
            $t('ui_prev')
          }}</a>
        </li>
        <li>
          <a href="javascript:;" @click="Next" class="nextmap-nav">{{
            $t('ui_next')
          }}</a>
        </li>
      </ul> -->
      <div
        class="scrollControl mapnavbtn noprint"
        :title="$t('ui_enableScroll')"
        @click="EnableScroll"
      >
        <span>
          <i class="fa" :class="[scrollEnabled ? 'fa-unlock' : 'fa-lock']"></i>
        </span>
      </div>
      <div
        class="scrollControl centering-btn noprint"
        @click="Center"
        :title="$t('ui_center')"
      >
        <span><i class="fa fa-circle"></i></span>
      </div>
      <div
        class="scrollControl terrain-btn noprint"
        @click="Terrain"
        :title="$t('ui_terrain')"
      >
        <span
          ><i
            class="fa"
            :class="[this.mapTypeId == 'terrain' ? 'fa-road' : 'fa-mountain']"
          ></i
        ></span>
      </div>
      <div
        class="scrollControl print-btn noprint"
        @click="MapPrint"
        :title="$t('ui_print')"
      >
        <span><i class="fas fa-print"></i></span>
      </div>
    </div>
    <!-- <span class="szuro-info">
      {{ markers.length }} / {{ switchFilteredMarkers.length }}
    </span> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import { AppStoreTypes } from '../../store/modules/app';
import { k_scrollTop, timeout } from '../../utils/common';
import { Statuszok } from '../../data/enums/kodszotar/statuszok';

export default {
  name: 'base-map',
  data() {
    return {
      zoom: 8,
      center: { lat: 47.3, lng: 21.2 },
      updatedCenter: { lat: 47.3, lng: 21.2 },
      scrollEnabled: false,
      mapTypeId: 'terrain',
      infoWindowPos: null,
      infoWinData: null,
      infoWinOpen: false,
      currentMidx: null,
      initCenterRetryCounter: 0,
      visibleMarkers: [],
      gmapLoaded: false,
    };
  },
  mounted() {
    this.$refs.gmap.$mapPromise.then(async () => {
      await this.$nextTick();
      this.gmapLoaded = true;
    });
  },
  created() {},
  methods: {
    ZoomIn() {
      if (this.zoom == 15) {
        return;
      }
      this.zoom += 1;
    },
    SetZoom(n) {
      this.zoom = n;
    },
    ZoomOut() {
      if (this.zoom == 7) {
        return;
      }
      this.zoom -= 1;
    },

    EnableScroll() {
      this.scrollEnabled = !this.scrollEnabled;
    },
    Terrain() {
      if (this.mapTypeId == 'terrain') {
        this.mapTypeId = 'roadmap';
      } else {
        this.mapTypeId = 'terrain';
      }
    },
    Center() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.MoveToPos(position.coords.latitude, position.coords.longitude);
        });
      }
    },
    MoveToPos(latitude, longitude) {
      this.CloseInfoWindow();
      if (this.$refs.gmap.$mapObject) {
        this.$refs.gmap.$mapObject.setCenter(
          new global.google.maps.LatLng(latitude, longitude)
        );
      } else {
        // Újrapróbálni, ha nem lehetetett beállítani
        if (this.initCenterRetryCounter < 5) {
          setTimeout(() => {
            this.initCenterRetryCounter++;
            this.MoveToPos(latitude, longitude);
          }, 500);
        }
      }
    },
    Prev() {
      let pos = this.currentMidx || 0;
      let maxIdx = this.switchFilteredMarkers.length - 1 || 0;
      let prevIdx = this.currentMidx - 1;

      if (prevIdx < 0) {
        prevIdx = maxIdx;
      }
      if (prevIdx > maxIdx) {
        prevIdx = 0;
      }
      this.OpenInfoWindowByIdx(prevIdx);
    },
    Next() {
      let pos = this.currentMidx || 0;
      let maxIdx = this.switchFilteredMarkers.length - 1 || 0;
      let nextIdx = this.currentMidx + 1;
      if (nextIdx > maxIdx) {
        nextIdx = 0;
      }
      this.OpenInfoWindowByIdx(nextIdx);
    },
    CloseInfoWindow() {
      const el = document.body;
      this.infoWinOpen = false;
      this.infoWinData = null;

      this.$emit('InfoWindowOpen', null);
    },
    OpenInfoWindow: function(id, scrollTop = true) {
      let idx = this.switchFilteredMarkers.findIndex(
        f => f.data[this.markerKey] == id
      );

      const el = document.body;
      if (idx > -1) {
        let marker = this.switchFilteredMarkers[idx];
        this.infoWindowPos = marker.position;
        //this.center = marker.position;
        this.infoWinData = marker.data;
        this.infoWinOpen = true;
        this.currentMidx = idx;
        if (scrollTop) {
          k_scrollTop();
        }
        this.$emit('InfoWindowOpen', marker.data);
      }
    },
    OpenInfoWindowByIdx: function(idx) {
      let marker = this.switchFilteredMarkers[idx];
      if (marker) {
        this.OpenInfoWindow(marker.data[this.markerKey]);
      }
    },
    async MapPrint() {
      await this.$parent.$refs.pdfAdditionalData.GetPontosCim();

      window.print();
    },
    async UpdateCenter(latLng) {
      this.updatedCenter = {
        lat: latLng.lat(),
        lng: latLng.lng(),
      };
    },
    Idle(e) {
      //this.SetMarkers();
    },
    VisibleOnMap(pos) {
      //return true;
      let bounds = this.$refs.gmap.$mapObject.getBounds();
      if (!bounds) {
        return false;
      }
      return bounds.contains(pos);
    },
    async SetMarkers() {
      let markers = this.markers2;
      await timeout(150);
      this.visibleMarkers = Object.freeze([...markers]);
    },
    ClusterClick(e) {
      let zoom = this.$refs.gmap.$mapObject.getZoom();
      let zoomStep = 2;
      if (zoom < 12) {
        zoomStep = 3;
      }

      this.$refs.gmap.$mapObject.setCenter(e.getCenter());
      this.$refs.gmap.$mapObject.setZoom(zoom + zoomStep);
    },
  },

  computed: {
    ...mapGetters({ selectedCountry: AppStoreTypes.selectedCountry.get }),
    google: gmapApi,
    isCleaned() {
      return this.$get(this.selectedData, 'Status') == Statuszok.Cleaned;
    },
    gridSize() {
      if (this.zoom == 7) {
        return 70;
      }
      if (this.zoom > 10) {
        return 20;
      }
      if (this.zoom > 14) {
        return 30;
      }
      return 40;
    },
    markers2() {
      if (this.gmapLoaded) {
        return this.markers;
      }
      return [];
    },
    infoOptions() {
      if (!this.google) {
        return null;
      }
      return {
        pixelOffset: {
          width: 0,
          height: -45,
        },
        zIndex: null,
        closeBoxMargin: '0',
        closeBoxURL: '',
        boxStyle: {
          maxWidth: '300px',
        },
      };
    },
    gmapsOptions() {
      return {
        scrollwheel: this.scrollEnabled,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        panControl: false,
        fullscreenControl: false,
        navigationControl: false,
        streetViewControl: false,
        //animation: VueGoogleMaps.gmapApi.maps.Animation.BOUNCE,
        gestureHandling: 'cooperative',
        mapTypeId: this.mapTypeId,
        styles: [
          {
            featureType: 'all',
            elementType: 'geometry.fill',
            stylers: [
              {
                weight: '2.00',
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#9C9C9C',
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.text',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'on',
              },
              {
                hue: '#00FF0E',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [
              {
                saturation: -100,
              },
              {
                lightness: 45,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#EEEEEE',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#7B7B7B',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#FFFFFF',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [
              {
                visibility: 'simplified',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'all',
            stylers: [
              {
                color: '#46BCEC',
              },
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#070707',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#FFFFFF',
              },
            ],
          },
        ],
      };
    },
    switchFilteredMarkers() {
      return this.markers.filter(f => f.visible);
    },
  },
  watch: {
    markers2: {
      handler: async function(val, prev) {
        let iwData = this.infoWinData;

        if (iwData) {
          let infoMarker = val.find(
            s => iwData[this.markerKey] == s.data[this.markerKey]
          );
          if (!infoMarker) {
            // InfoWindow bezárása, ha nincs már a markerek közözz, amire mutat
            this.CloseInfoWindow();
          } else {
            // InfoWindow mozgatása, frissítése
            this.infoWinData = infoMarker.data;
            this.infoWindowPos = infoMarker.position;
          }
        }
        this.SetMarkers();
      },
      immediate: true,
      deep: true,
    },
    infoWinData: {
      handler: function(val) {
        this.$emit('update:selectedData', val);
      },
      immediate: false,
      deep: true,
    },
    selectedCountry: {
      handler: function(val) {
        console.log(val);
        if (val.Latitude > 0 && val.Longitude > 0) {
          this.MoveToPos(val.Latitude, val.Longitude);
          this.SetZoom(8);
        }
        if (val.ResourceKey == 'ui_countryAll') {
          this.SetZoom(7);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {},
  props: {
    markers: {
      type: Array,
      default: function() {
        return [];
      },
    },
    markerKey: {
      type: String,
      required: true,
    },
    selectedData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    visibleNavigation: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.gm-style-iw-d {
  overflow: inherit;
}

.map-popup-category {
  top: 135px !important;
  box-shadow: 0px 0px 0px 3px rgba(255, 255, 255, 0.7) !important;
}

.terrain-btn {
  right: 158px;
}
</style>
